.header {
    font-size: 1.5em;
    margin-right: 20px;
    font-weight: bold;
}

.failed{
    margin-top: 8%;
    margin-left: 20%;
    padding-top: 7%;
    padding-bottom: 7%;
    border: 1px solid #c21020;
    border-radius: 5px;
    color: #c21020;
    width: 60%;
    text-align: center;
    background-color: #f3cfd2;
}

.success{
    margin-top: 8%;
    margin-left: 25%;
    padding-top: 7%;
    padding-bottom: 7%;
    border: 1px solid #367c2b;
    border-radius: 5px;
    color: #367c2b;
    width: 50%;
    text-align: center;
    background-color: #F0FFF0;
}
